import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {I18nModule,} from '@spartacus/core';
import {SpinnerModule} from '@spartacus/storefront';
import {AimoCloseAccountComponent} from "./aimo-close-account.component";

@NgModule({
    imports: [
        CommonModule,
        SpinnerModule,
        I18nModule,
    ],
    declarations: [
        AimoCloseAccountComponent,
    ],
    exports: [AimoCloseAccountComponent],
})
export class AimoCloseAccountModule {
}
